import { useContext } from 'react';
import { EquipoAlineacionesContext } from '../../equipo/EquipoAlineacionesContext';
import { PartidoAlineacionesContext } from '../../partido/PartidoAlineacionesContext';

/**
 * Hook unificado que funciona tanto en contexto de Equipo como de Partido
 * Lee ambos contextos de forma segura sin violar las reglas de hooks
 *
 * IMPORTANTE: Siempre llama a useContext dos veces (cumple con Rules of Hooks)
 * La lógica condicional solo ocurre después de obtener ambos valores
 */
export const useAlineacionesContext = () => {
    // SIEMPRE leer ambos contextos (no hay try-catch ni condicionales)
    // Esto cumple con las Rules of Hooks
    const equipoContext = useContext(EquipoAlineacionesContext);
    const partidoContext = useContext(PartidoAlineacionesContext);

    // Después de obtener los valores, decidir cuál devolver
    // Si ambos existen, priorizar el de equipo
    if (equipoContext) {
        return equipoContext;
    }

    if (partidoContext) {
        return partidoContext;
    }

    // Si ninguno existe, devolver objeto vacío con valores por defecto
    return {
        editorLineups: null,
        selectedEditorLineup: null,
        setSelectedEditorLineup: () => {},
    };
};
